import { ReactElement, ReactNode } from 'react'

import Tooltip, { TooltipProps } from '@mui/material/Tooltip'
import { colors } from '@theme/variables'

export const CustomTooltip = ({
  children,
  title,
  color = colors.primary,
  arrow,
  padding,
  open,
  onOpen,
  onClose,
  placement,
  width,
}: {
  title: ReactNode
  children: ReactElement
  color?: string
  arrow?: boolean
  padding?: string
  open?: boolean
  onOpen?: () => void
  onClose?: () => void
  placement?: TooltipProps['placement']
  width?: string
}) => (
  <Tooltip
    onClose={onClose}
    onOpen={onOpen}
    open={open}
    title={title}
    arrow={arrow ?? true}
    placement={placement}
    describeChild
    disableFocusListener
    leaveDelay={300}
    slotProps={{
      tooltip: {
        sx: {
          pointerEvents: 'auto',
          maxWidth: width || 'none',
          backgroundColor: color,
          padding: padding || '10px',
          '& .MuiTooltip-arrow': {
            color,
          },
          '& .MuiTooltip-arrow:before': {
            borderColor: `${color} transparent`,
          },
        },
      },
    }}
  >
    {children || ''}
  </Tooltip>
)
